import { Controller } from "@hotwired/stimulus"

// Toggles the long-only fields on the admin testimonial form and shows a
// live slug preview derived from author_name. Data fields in the form
// supply hidden/visible markers as `hidden` class toggles.
export default class extends Controller {
  static targets = [
    "formatRadio",
    "longSection",
    "bodyField",
    "bodyLabelShort",
    "bodyLabelLong",
    "authorField",
    "authorHintShort",
    "authorHintLong",
    "slugPreview"
  ]

  connect() {
    this.applyFormat()
    this.updateSlugPreview()
  }

  formatChanged() {
    this.applyFormat()
  }

  authorChanged() {
    this.updateSlugPreview()
  }

  applyFormat() {
    const isLong = this.currentFormat() === "long"
    this.longSectionTarget.classList.toggle("hidden", !isLong)
    this.bodyLabelShortTarget.classList.toggle("hidden", isLong)
    this.bodyLabelLongTarget.classList.toggle("hidden", !isLong)
    this.authorHintShortTarget.classList.toggle("hidden", isLong)
    this.authorHintLongTarget.classList.toggle("hidden", !isLong)
    this.bodyFieldTarget.style.minHeight = isLong ? "20rem" : "8rem"
  }

  currentFormat() {
    const selected = this.formatRadioTargets.find(r => r.checked)
    return selected ? selected.value : "short"
  }

  updateSlugPreview() {
    if (!this.hasSlugPreviewTarget) return
    const slug = this.slugify(this.authorFieldTarget.value)
    this.slugPreviewTarget.textContent = slug || "..."
  }

  slugify(value) {
    return value
      .toString()
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/æ/g, "ae")
      .replace(/ø/g, "oe")
      .replace(/å/g, "aa")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }
}
